import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, NgForm, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { DocumentService } from 'src/app/core/services/document.service';
import { Message } from 'src/app/core/class/message';
import { Common } from 'src/app/core/constants/common';
import { ActivatedRoute, Router } from '@angular/router';
import * as uuid from 'uuid';
@Component({
  selector: 'app-add-approver-dialog',
  templateUrl: './add-approver-dialog.component.html',
  styleUrls: ['./add-approver-dialog.component.scss']
})
export class AddApproverDialogComponent implements OnInit {

  listApprover: any[]= []
  addApproverForm: FormGroup
  valid = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AddApproverDialogComponent>,
    private documentService: DocumentService,
    private toastr: ToastrService,
    private message: Message,
    private router: Router,
    private fb: FormBuilder
  ) { }

  ngOnInit() {
    this.addApproverForm = this.fb.group({
      approve: this.fb.array([], this.checkDuplicateEmail('email'))
    })
    if(this.data.check == 2){
      this.onAddAproverClick()
    }
    this.seedForm()
  }

  seedForm(){
    if(this.data.data == 0){
      this.listApprover.forEach((data: any)=>{
      const formGroup = this.fb.group({})
      formGroup.addControl('email', this.getFormControlWidthEmailValidate())
      formGroup.addControl('fullName', this.getFormControlWidthNameValidate())
      formGroup.addControl('phoneNumber', this.getFormControl())
      formGroup.addControl('CTS', this.getFormControlCheckbox())
      formGroup.addControl('showImage', this.getFormControlCheckbox())
        formGroup.addControl('taxCode', this.getFormControlTaxCode())
        formGroup.addControl('taxCodeNew', this.getFormControlTaxCodeNew())
        formGroup.addControl('userId', this.getFormControlUserId())
      // formGroup.addControl('CTS', this.getFormControl())
      // formGroup.addControl('showImage', this.getFormControl())
      formGroup.patchValue(data)
      this.approverFormArray.push(formGroup)
    })
    }
    else {
      this.listApprover = this.data.data;
      this.listApprover.forEach((data: any)=>{
        const formGroup = this.fb.group({})
        formGroup.addControl('email', this.getFormControlWidthEmailValidate())
        formGroup.addControl('fullName', this.getFormControlWidthNameValidate())
        formGroup.addControl('phoneNumber', this.getFormControl())
        formGroup.addControl('CTS', this.getFormControlCheckbox())
        formGroup.addControl('showImage', this.getFormControlCheckbox())
        formGroup.addControl('taxCode', this.getFormControlTaxCode())
        formGroup.addControl('taxCodeNew', this.getFormControlTaxCodeNew())
        formGroup.addControl('userId', this.getFormControlUserId())
        // formGroup.addControl('CTS', this.getFormControl())
        // formGroup.addControl('showImage', this.getFormControl())
        formGroup.patchValue(data)
        this.approverFormArray.push(formGroup)
      })
    }

  }

  getFormControlWidthEmailValidate(){
    return this.fb.control('', [Validators.required, Validators.pattern(Common.EMAIL_PATTERN)])
  }

  getFormControlWidthNameValidate(){
    return this.fb.control('',[Validators.required])
  }

  getFormControlTaxCode(){
    return this.fb.control('',[Validators.required,Validators.pattern(/^[0-9]*$/)])
  }

  getFormControl(){
    return this.fb.control('',[Validators.pattern(/([\+84|84|0]+(3|5|7|8|9|1[2|6|8|9]))+([0-9]{8})\b/), Validators.minLength(10), Validators.maxLength(12)])
  }

  getFormControlCheckbox(){
    return this.fb.control(false)
  }

  getFormControlTaxCodeNew(){
    return this.fb.control('',[Validators.pattern(/^[0-9]*$/)])
  }

  getFormControlUserId(){
    return this.fb.control(null)
  }

  duplicates = [];
  checkDuplicateEmail(fieldName){
    return (formArray: FormArray): { [key: string]: any } | null => {
      if (this.duplicates) {
        for (var i = 0; i < this.duplicates.length; i++) {

          let errors =
            (formArray.at(this.duplicates[i]).get(fieldName)
              .errors as Object) || {};
          delete errors['duplicated'];

          formArray
            .at(this.duplicates[i])
            .get(fieldName)
            .setErrors(Object.keys(errors).length ? errors : null);
        }
      }

      let dict = {};
      formArray.value.forEach((item, index) => {

        dict[item[fieldName]] = dict[item[fieldName]] || [];
        dict[item[fieldName]].push(index);
      });
      let duplicates = [];
      for (var key in dict) {
        if (key) {
          if (dict[key].length > 1) duplicates = duplicates.concat(dict[key]);
        }

      }
      this.duplicates = duplicates;

      for (const index of duplicates) {
        const control = formArray.at(+index).get(fieldName);
        const errors = Object.assign(control.errors || {}, {duplicated: true})
        formArray
          .at(+index)
          .get(fieldName)
          .setErrors(errors);
      }

      return duplicates.length > 0 ? { error: 'Has Duplicate !!!' } : null;
    };
  }

  onAddAproverClick(){
    // if(this.data.data.length == 0){
      if((this.approve.length +1) > this.data.document.maxUserApprove){
        this.toastr.error(this.message.getMessage('approved.max_user_approval').replace('{0}', this.data.document.maxUserApprove))
        return
      }
      const formGroup = this.fb.group({})
      formGroup.addControl('email', this.getFormControlWidthEmailValidate())
      formGroup.addControl('fullName', this.getFormControlWidthNameValidate())
      formGroup.addControl('phoneNumber', this.getFormControl())
      formGroup.addControl('CTS', this.getFormControlCheckbox())
      formGroup.addControl('showImage', this.getFormControlCheckbox())
      formGroup.addControl('taxCode', this.getFormControlTaxCode())
      formGroup.addControl('taxCodeNew', this.getFormControlTaxCodeNew())
    formGroup.addControl('userId', this.getFormControlUserId())
      // formGroup.addControl('CTS', this.getFormControl())
      // formGroup.addControl('showImage', this.getFormControl())
      this.approverFormArray.push(formGroup)
    // }

  }

  get approverFormArray(){
    return (<FormArray>this.addApproverForm.get('approve'))
  }

  get approve(): FormArray{
    return this.addApproverForm.get('approve') as FormArray
  }

  onDeleteApprover(index: any){
    this.approverFormArray.removeAt(index)
  }

  onCancel(){
    this.dialogRef.close();
  }

  onSave(){
    // if(this.approve.invalid){
    //   this.approve.markAllAsTouched();
    //   return
    // }
    var patternMail = /^[_A-Za-z0-9-\+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/;
    var patternPhone = /([\+84|84|0]+(3|5|7|8|9|1[2|6|8|9]))+([0-9]{8})\b/;
    var patternNumber = /^[0-9]*$/;
    for (var i = 0;i < this.approve.value.length;i++){
      if(!this.approve.value[i].fullName){
        this.approve.markAllAsTouched();
        this.valid = false;
        break;
      }
      else {
        this.valid = true;
      }
      if(!this.approve.value[i].email || !patternMail.test(this.approve.value[i].email)){
        this.approve.markAllAsTouched();
        this.valid = false;
        break;
      }
      else {
        this.valid = true;
      }
      if(this.approve.value[i].CTS && (!this.approve.value[i].taxCode || !patternNumber.test(this.approve.value[i].taxCode))){
        this.approve.markAllAsTouched();
        this.valid = false;
        break;
      }
      else {
        this.valid = true;
      }
      if(this.approve.value[i].phoneNumber &&  (!patternPhone.test(this.approve.value[i].phoneNumber) || this.approve.value[i].phoneNumber.length < 10 || this.approve.value[i].phoneNumber.length > 12) ){
        this.approve.markAllAsTouched();
        this.valid = false;
        break;
      }
      else {
        this.valid = true;
      }
      if(this.approve.value[i].taxCodeNew &&  !patternNumber.test(this.approve.value[i].taxCodeNew)){
        this.approve.markAllAsTouched();
        this.valid = false;
        break;
      }
      else {
        this.valid = true;
      }
      const checkMail = this.approve.value.filter(ala => ala.email === this.approve.value[i].email )
      if(checkMail.length > 1){
        this.approve.markAllAsTouched();
        this.valid = false;
        break;
      }
      else {
        this.valid = true;
      }
    }
   if(this.valid){
     for (var i = 0;i < this.approve.value.length;i++){
       if(!this.approve.value[i].userId){
         this.approve.value[i].userId = uuid.v4();
       }
     }
     let valueAddApprover = {
       contractId: this.data.document.id,
       userApproves: this.approve.value
     }
     this.dialogRef.close(valueAddApprover);
   }
    // if(this.data.hasLogin){
    //   this.documentService.addApproverContract(valueAddApprover).subscribe(res => {
    //     if (!res.success) {
    //       this.toastr.error(res.message);
    //       return
    //     } else {
    //       this.toastr.success(this.message.getMessage('approved.add_approver_success'));
    //       localStorage.removeItem('approvalToken');
    //       // Khi close dialog, load lại dữ liệu trang
    //       this.dialogRef.close(true);
    //       return;
    //     }
    //   });
    //   return
    // }else{
    //   this.documentService.addApproverContractAnonymous(valueAddApprover).subscribe(res => {
    //     console.log('addApproverContractAnonymous', res)
    //     if (!res.success) {
    //       this.toastr.error(res.message);
    //       return
    //     } else {
    //       this.toastr.success(this.message.getMessage('approved.add_approver_success'));
    //       localStorage.removeItem('approvalToken');
    //       // Khi close dialog, load lại dữ liệu trang
    //       this.dialogRef.close(true);
    //       return;
    //     }
    //   });
    // }
  }
  changeCTS(i){
    if(this.approve.controls[i].get('CTS').value){
      if(this.data.checkAnhKy){
        this.approve.controls[i].get('showImage').setValue(true);
      }
      this.approve.controls[i].get('taxCode').setValue(this.approve.controls[i].get('taxCodeNew').value);
    }
    else {
      this.approve.controls[i].get('showImage').setValue(false);
      this.approve.controls[i].get('taxCodeNew').setValue(this.approve.controls[i].get('taxCode').value);
    }
  }
  onNoClick() {
    this.dialogRef.close();
  }

  checkFocusOutFullname(i){
    this.approve.controls[i].get('fullName').patchValue(this.approve.controls[i].get('fullName').value.trim())
  }

  checkFocusOutTaxCode(i){
    this.approve.controls[i].get('taxCode').patchValue(this.approve.controls[i].get('taxCode').value.trim())
  }

  checkFocusOutTaxCodeNew(i){
    this.approve.controls[i].get('taxCodeNew').patchValue(this.approve.controls[i].get('taxCodeNew').value.trim())
  }

  checkFocusOutEmail(i){
    this.approve.controls[i].get('email').patchValue(this.approve.controls[i].get('email').value.trim())
  }

  checkFocusOutPhone(i){
    this.approve.controls[i].get('phoneNumber').patchValue(this.approve.controls[i].get('phoneNumber').value.trim())
  }

}
